// extracted by mini-css-extract-plugin
export var section = "runDevice-module--section--AJ5p8";
export var inner = "runDevice-module--inner--1Hckt";
export var jsAnimInit = "runDevice-module--jsAnimInit--3PxWC";
export var title = "runDevice-module--title--3G1bB";
export var description = "runDevice-module--description--1bcve";
export var imgWrap = "runDevice-module--imgWrap--38vbr";
export var content = "runDevice-module--content--7ebjp";